/* @flow */
import Dialog from 'components/Dialog.jsx';
import Group from 'entities/Group';
import GroupEditPanel from './GroupEditPanel.jsx';
import GroupMemberList from './GroupMemberList.jsx';
import React from 'react';
import TabPanel from 'components/TabPanel.jsx';
import Tabs from 'components/Tabs.jsx';

type Props = {
  group: Group,
  onCodeChange: Function,
  onRequestHide?: Function,
  userIsTeacher: boolean,
};

class GroupSettingsModal extends React.Component<Props> {
  renderGroupInformationPanel = () => {
    const { group, onCodeChange, userIsTeacher, onRequestHide } = this.props;
    return (
      <GroupEditPanel
        group={group}
        onCodeChange={onCodeChange}
        userIsTeacher={userIsTeacher}
        onRequestHide={onRequestHide}
      />
    );
  };

  renderGroupOwnerManagerPanel = () => {
    return (
      <GroupMemberList
        className="GroupMemberList"
        group={this.props.group}
        onRequestHide={() => {}}
      />
    );
  };

  render() {
    return (
      <Dialog
        eventScreenName="GroupSettingsModal"
        className="GroupSettingsModal"
        title="Class settings"
        onCodeChange={this.props.onCodeChange}
        onRequestHide={this.props.onRequestHide}
        size="small">
        <Tabs tabAlign="center">
          <TabPanel title={<span>Information</span>}>{this.renderGroupInformationPanel()}</TabPanel>
          <TabPanel title={<span>Owners</span>}>{this.renderGroupOwnerManagerPanel()}</TabPanel>
        </Tabs>
      </Dialog>
    );
  }
}

export default GroupSettingsModal;
